import { ManagerData } from 'api/types/data';
import { GridFields } from 'components';
import { formatToDateTime } from 'helpers';
import { useConvertDateToUserTimezone } from 'hooks';
import { useFormContext } from 'libs/form/useFormContext';
import { useTranslation } from 'libs/i18n';
import { Input } from 'libs/ui';

interface Props {
  createdBy: ManagerData | null;
  createdAt: Date;
  result?: string | null;
}

export const StatusFields = ({ createdAt, createdBy, result }: Props) => {
  const { t } = useTranslation();

  const { readOnly } = useFormContext();

  const { convertDateToUserTimezone } = useConvertDateToUserTimezone();

  return (
    <GridFields>
      {result && (
        <Input
          readOnly
          showCopyButton
          disabled={!readOnly}
          label={t('client.client.resultCheckSection.resultLabel')}
          value={result}
        />
      )}

      {createdBy && (
        <Input
          fullWidth
          readOnly
          showCopyButton
          disabled={!readOnly}
          label={t('client.client.resultCheckSection.createdByLabel')}
          value={createdBy.name}
        />
      )}

      <Input
        fullWidth
        readOnly
        showCopyButton
        disabled={!readOnly}
        label={t('client.client.resultCheckSection.createdAtLabel')}
        value={formatToDateTime(convertDateToUserTimezone(createdAt))}
      />
    </GridFields>
  );
};
